import React from 'react';
import css from './SectionOuterContainer.scss';
import PropTypes from 'prop-types';
import StudentIntakeStatusBar from './StudentIntakeStatusBar';
import StudentIntakeHeader from './StudentIntakeHeader'
import StaffIntakeHeader from './StaffIntakeHeader';

function SectionOuterContainer(props) {

  const getIntakeStatusActionBar = () => !props.isHopeForm &&
    <StudentIntakeStatusBar
      authorName={props.authorName}
      lastUpdatedDate={props.lastUpdatedDate}
      abbreviatedTZ={props.abbreviatedTZ}
      isEditable={props.isEditable}
      canEditIntakeForm={props.canEditIntakeForm}
      studentId={props.studentId}
      onEditClick={props.onEditClick}
      multipleStudentSurveysEnabled={props.multipleStudentSurveysEnabled}
    />;

  const getStudentLanguageHeader = () => props.viewingAsStudent
    ? <StudentIntakeHeader
          surveyTitle={props.surveyTitle}
          isHopeForm={props.isHopeForm}
          multipleStudentSurveysEnabled={props.multipleStudentSurveysEnabled} />
    : <StaffIntakeHeader />;

  return (
    <div className={css['student-intake-container']}>
      <div className={css['student-intake-content']}>
        {getIntakeStatusActionBar()}
        {getStudentLanguageHeader()}
        {props.children}
      </div>
    </div>
  );
}

SectionOuterContainer.propTypes = {
  surveyTitle: PropTypes.string,
  authorName: PropTypes.string,
  viewingAsStudent: PropTypes.bool,
  isHopeForm: PropTypes.bool.isRequired,
  lastUpdatedDate: PropTypes.string,
  abbreviatedTZ: PropTypes.string,
  isEditable: PropTypes.bool,
  studentId: PropTypes.number.isRequired,
  onEditClick: PropTypes.func.isRequired,
  canEditIntakeForm: PropTypes.bool.isRequired,
  multipleStudentSurveysEnabled: PropTypes.bool
};

export default SectionOuterContainer;
